@if (isVisible) {
  <div class="modal">
    <div class="modal__content">
      <ng-content></ng-content>
    </div>
    <ysh-button-control type="exit" position="top-right" (click)="didTapClose()"/>
  </div>
}
